import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/fabricante';
import Fabricante from './Fabricante';


const ms2p = (state) => {
  return {
    ...state.rs_fabricante,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Fabricante);
